import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CONFIG } from '@cpd-app/configuration';
import { BUILD_YOUR_TARGET_PATH } from '@cpd-app/core-module/constants/routes';

import { RouteStateService } from '@cpd-app/core-module/services';
import { AuthFacade } from '@cpd-app/state/auth';
import { DeviceFacade } from '@cpd-app/state/device/device.facade';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { footerLinksFor } from './footer-links';

import { TeamDialogComponent } from '../team-dialog/team-dialog.component';

@Component({
  selector: 'cpd-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public links = CONFIG.FOOTER_LINKS;

  /** MOBILE.1 D10. The staff links drop off on a phone for anyone without the
   * role; see footerLinksFor. */
  public readonly visibleLinks$ = combineLatest([
    inject(DeviceFacade).isSmallerThanValue$(600),
    inject(AuthFacade).isAdmin$,
    inject(AuthFacade).isCounselorOrAbove$
  ]).pipe(
    map(([isPhone, isAdmin, isCounselor]) =>
      footerLinksFor(this.links, {
        isPhone: !!isPhone,
        isAdmin: !!isAdmin,
        isCounselor: !!isCounselor
      })
    )
  );
  // Replaces the empty <a routerLinkActive> probe anchor; see RouteStateService.
  public readonly routeState = inject(RouteStateService);

  constructor(
    public dialog: MatDialog,
    private router: Router
  ) {}

  public get isYourTargetRoute(): boolean {
    // The landing page moved from Build Your Target to /home; the cookie
    // preferences control follows it.
    return (
      this.router.url.includes(BUILD_YOUR_TARGET_PATH) ||
      this.router.url.startsWith('/home')
    );
  }

  public aboutUs(): void {
    this.dialog.open(TeamDialogComponent, {
      ariaLabel: 'About Career Path DECIDE',});
  }
}
